import { render, staticRenderFns } from "./studentinfo.vue?vue&type=template&id=f43fa506&scoped=true&"
import script from "./studentinfo.vue?vue&type=script&lang=js&"
export * from "./studentinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43fa506",
  null
  
)

export default component.exports